import { Address } from '@kanda-libs/ks-frontend-services';

export const EXAMPLE_ADDRESS: Address = {
  building_number: '17',
  line_1: '17 High Street',
  city: 'Henley-in-Arden',
  county: 'West Midlands',
  country: 'England',
  postcode: 'B95 5AA',
};

export const YOUR_INFO_CLASS_NAMES = {
  titleWrapper: 'flex flex-row gap-x-3  mb-3 items-center',
  title: 'text-16-24-em text-neutral-900',
  subtitle: 'text-14-22 text-neutral-700 mb-6 -mt-2 first:mt-0',
  subheading: 'text-style-f-em text-neutral-700 mb-6 -mt-2 first:mt-0',
  description: 'text-style-g text-neutral-700 mb-6',
  heading: 'text-style-g-em text-neutral-700 mb-6',
};
